/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Publish_Review_Failed_ToastInputs */

const en_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const fr_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const de_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const it_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const ru_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const es_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const zh_cn2_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const ja_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const hi_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

const pt_pt2_iconik_publish_review_failed_toast = /** @type {(inputs: Iconik_Publish_Review_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Publish completed, but the review request failed: {error}" |
*
* @param {Iconik_Publish_Review_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_review_failed_toast = /** @type {((inputs: Iconik_Publish_Review_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Review_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_review_failed_toast(inputs)
	if (locale === "de") return de_iconik_publish_review_failed_toast(inputs)
	if (locale === "it") return it_iconik_publish_review_failed_toast(inputs)
	if (locale === "ru") return ru_iconik_publish_review_failed_toast(inputs)
	if (locale === "es") return es_iconik_publish_review_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_review_failed_toast(inputs)
	if (locale === "ja") return ja_iconik_publish_review_failed_toast(inputs)
	if (locale === "hi") return hi_iconik_publish_review_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_review_failed_toast(inputs)
	return en_iconik_publish_review_failed_toast(inputs)
});